import { Button, Card, Drawer } from "antd";
import React, { useEffect, useState } from "react";
import AddS from "../components/Services/AddS";
import { AddonServices } from "../Services/AddonServices";
import TableS from "../components/Services/TableS";
import { notify } from "../customs/NotifyProvider";
import { ProductServices } from "../Services/ProductServices";

const Services = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);

  const getAddonServices = async () => {
    try {
      const request = await AddonServices.getAllServices();
      setData(request.data);

      console.log(request.data);

    } catch (error) {
      console.error(error);

    }
  }

  const handleEdit = (id) => {
    try {
      // const request = await 
      console.log(id);
      setEditId(id);
      setOpen(true);

    } catch (error) {
      console.error(error);

    }
  }


  const handleDelete = async (record) => {
    try {
      const baseUrl = "/assets/service/";
      const uploadImg = record.upload_img || "";
      console.log("Deleted file:", uploadImg);
      let fileName = "";
      if (uploadImg) {
        fileName = uploadImg.replace(baseUrl, "").split("?")[0];
        console.log(fileName);
      }
      if (fileName) {
        const response = await ProductServices.deleteUploadedFile({
          file_path: 'assets/service',
          file_name: fileName
        });
        if (!response) {
          console.warn("File deletion failed, but continuing to delete car record.");
        }
      }
      const req = await AddonServices.deleteServicesById(record.id);
      if (req.status) {
        notify.success("Success", req.message);
        getAddonServices();
      } else {
        notify.error("Something went wrong", req.message);
        getAddonServices();
      }
    } catch (error) {
      console.error("Error deleting car:", error);
      getAddonServices();
    }
  };


  useEffect(() => {
    getAddonServices();
  }, [])

  return (
    <>
      <Card
        title="Manage Services"
        extra={
          <Button
            type="primary"
            ghost
            onClick={() => setOpen(true)}
          >
            Create Services
          </Button>
        }
      >
        <TableS data={data}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      </Card>


      <Drawer
        title={editId ? "Edit  Service" : "Create  Service"}
        width={520}
        open={open}
        onClose={() => {
          setOpen(false);      // close drawer
          setEditId(null);     // clear editId
        }}
        destroyOnClose
      >
        <AddS
          closeDrawer={() => {
            setOpen(false);
            setEditId(null);   // ensure data cleared if closing from inside AddS
          }}
          getAddonServices={getAddonServices}
          editorId={editId}
        />
      </Drawer>
    </>
  );
};

export default Services;
